import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ComponentBase } from '../../_utils/component.base';
import { CategorySimulationType } from '../../_utils/custom-types';
import { ModuleEnum } from '../../_utils/unums/module.enum';
import { AvatarSimulationProgressPipe } from '../../_pipes/avatar-simulation-progress.pipe';
import { SimulationService } from '../../_services/simulation.service';
import { lastValueFrom } from 'rxjs';
import { UserSimulationsService } from '../../_services/user-simulations.service';

@Component({
  selector: 'app-circle-progress-bar',
  templateUrl: './circle-progress-bar.component.html',
  styleUrls: ['./circle-progress-bar.component.scss']
})
export class CircleProgressBarComponent extends ComponentBase implements OnInit, OnChanges {
  @Input()
  public progressColor: string;
  @Input()
  public simulationType: CategorySimulationType;
  @Input()
  public module: ModuleEnum;
  @Input()
  public simulations: any[];

  protected progress: any;
  protected progressNumberClass: string;
  protected hashId: number;

  constructor(
    private avatarSimulationProgressPipe: AvatarSimulationProgressPipe,
    private simulationService: SimulationService,
  ) {
    super();
    this.initVariables();
  }

  ngOnInit() {
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes.simulations?.currentValue && this.simulationType === 'avatar') {
      const maxSimulations = this.simulations
        .sort((a, b) => b.scoring - a.scoring)
        .filter((simulation, index, simulations) =>
          simulations.findIndex(x => x.simulationId === simulation.simulationId) === index);
      const simulationLevels = await Promise.all(maxSimulations.map(async simulation => ({
        ...simulation,
        level: (await lastValueFrom(this.simulationService.getSimulationPropertyById(simulation.simulationId, 'level'))).data,
        attempts: [simulation]
      })));

      const simulationProgressSettings = await this.userJourneyService.getSimulationProgressSetting();
      this.progress = await this.avatarSimulationProgressPipe.transform(simulationLevels, this.module, simulationProgressSettings);
      this.progressNumberClass = 'p' + Math.round(this.progress.percent ?? 0);
    }
  }

  private initVariables(): void {
    this.progressColor = 'blue';
    this.simulationType = 'avatar';
    this.progressNumberClass = 'p0';
    this.module = ModuleEnum.feedback;
    this.hashId = Date.now();
  }
}
